import { useEffect, useState } from 'react';
import {
  CONFIG_KEYS_UPDATED_EVENT,
  getConfigKeyContent,
  invalidateConfigKeysCache,
} from '@/services/config/config-keys-store';

export const CONFIG_KEY_CANH_BAO_KPI_3KY = 'config_setting_canhbao_kpi_3ky_lientiep';

/** Checkbox Cấu hình: Cảnh báo KPI 3 kỳ liên tiếp (mặc định bật). */
export function useCanhBaoKPIBaKyLienTiepEnabled() {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = () => {
      setLoading(true);
      void getConfigKeyContent(CONFIG_KEY_CANH_BAO_KPI_3KY, 'true')
        .then((value) => {
          if (!cancelled) {
            setEnabled(value === 'true');
            setLoading(false);
          }
        })
        .catch(() => {
          if (!cancelled) {
            setEnabled(true);
            setLoading(false);
          }
        });
    };

    load();

    const onConfigKeysUpdated = () => {
      load();
    };
    window.addEventListener(CONFIG_KEYS_UPDATED_EVENT, onConfigKeysUpdated);

    return () => {
      cancelled = true;
      window.removeEventListener(CONFIG_KEYS_UPDATED_EVENT, onConfigKeysUpdated);
    };
  }, []);

  return {
    enabled: enabled ?? true,
    loading,
  };
}

export function invalidateCanhBaoKPIBaKyLienTiepConfigCache() {
  invalidateConfigKeysCache();
}
